
export default {
    name: 'param-printer',
    components: {},
    props: {
        print_data: {
            type: Object,
            default: () => ({})
        },
        print_toggler: Number
    },

    watch: {
        print_toggler() {
            if (this.print_data.data_type == 'examens') {
                this.printData()
            } else if (this.print_data.data_type == 'consultations') {
                this.printConsultationData()
            }  else if (this.print_data.data_type == 'chirurgies') {
                this.printChirurgie()
            } else if (this.print_data.data_type == 'bilan_sante') {
                this.printBilanSante()
            }
        }
    },

    data() {
        return {
            can_print: false,
            can_print_consultation: false,
            can_print_chirurgie: false,
            can_print_bilan_sante: false
        }
    },

    computed: {
        
    },

    mounted() {
        
    },

    methods: {
        printData() {
            this.can_print = true
            setTimeout(() => {
                window.print()
                this.can_print = false
            }, 500);
        },

        printConsultationData() {
            this.can_print_consultation = true
            setTimeout(() => {
                window.print()
                this.can_print_consultation = false
            }, 500);
        },

        printChirurgie() {
            this.can_print_chirurgie = true
            setTimeout(() => {
                window.print()
                this.can_print_chirurgie = false
            }, 500);
        },

        printBilanSante() {
            this.can_print_bilan_sante = true
            setTimeout(() => {
                window.print()
                this.can_print_bilan_sante = false
            }, 500);
        }
    }
}